/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Sync_Property_Position_HelpInputs */



/**
* | output |
* | --- |
* | "Horizontal position, vertical position, and alignment" |
*
* @param {Event_Group_Sync_Property_Position_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_sync_property_position_help = /** @type {((inputs?: Event_Group_Sync_Property_Position_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Sync_Property_Position_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "de") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "it") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "es") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
	return /** @type {LocalizedString} */ ("Horizontal position, vertical position, and alignment")
});